<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bp8oiB/images/image-9781452460031_imgjpg_frontcover_0.jpg?1684515371169" alt="This image is the cover for the book Princess Sultana's Daughters, Princess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Princess Sultana's Daughters, Princess
      </h1>
      <p class="bookDescription body article font2">
        <p>In the compelling second novel of the Princess series, Jean Sasson and Princess Sultana turn the spotlight on Sultana's two teenage daughters, Maha and Amani. As second generation members of the royal family who have benefited from Saudi oil wealth, Maha and Amani have been surrounded by untold opulence and luxury since the day they were born. And yet, they are stifled by the unbearably restrictive lifestyle imposed on them, driving them to desperate measures. While exploring the troubles of Princess Sultana's daughters, Sultana and Sasson never tire in their quest to expose the injustices Saudi Arabian society levels against women. Princess Sultana once more strikes a chord among all women who are lucky enough to have the freedom to speak out for themselves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean Sasson
      </h2>
      
      <p class="authorDescription body article">Jean Sasson grew up in a small town in Alabama—her mind always in a book and her hands always searching for something new to read. Today, Jean is still a voracious reader as wells as a  sharp-eyed, compassionate chronicler of women's lives in the Muslim World</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ad2adde6